import React from 'react';
import PropTypes from 'prop-types';

import DisplayQuality from './DisplayQuality';
import EmptyDisplayQuality from './EmptyDisplayQuality';

export default function PossibleDisplayQualityComponent({
  isChanging,
  item,
  onClick,
}) {
  if (item) {
    return (
      <DisplayQuality
        isChanging={isChanging}
        item={item}
        onClick={onClick}
      />
    );
  }
  return (
    <EmptyDisplayQuality isChanging={isChanging} onClick={onClick} />
  );
}

PossibleDisplayQualityComponent.propTypes = {
  isChanging: PropTypes.bool.isRequired,
  item: PropTypes.shape({}),
  onClick: PropTypes.func.isRequired,
};

PossibleDisplayQualityComponent.defaultProps = {
  item: null,
};